import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import { SkeletonBox } from '@/components';

export const EmojiPickerSkeleton = ({ width = '320px', height = '350px' }) => {
  return (
    <div
      style={{ width, height }}
      className="bg-white rounded-2xl p-4 shadow-xl border border-gray-200 flex flex-col gap-3 overflow-hidden select-none"
    >
      {/* Category Icons Skeleton Header */}
      <div className="flex justify-between items-center px-1 my-1 border-b border-gray-100 pb-2">
        {[...Array(9)].map((_, i) => (
          <SkeletonBox key={i} className="w-5 h-5" rounded="rounded-full" />
        ))}
      </div>
      {/* Search Input Skeleton */}
      <SkeletonBox className="w-full h-9" rounded="rounded-xl" />
      {/* Category Title Skeleton */}
      <SkeletonBox className="w-32 h-4 mt-1 mb-1" rounded="rounded-md" />
      {/* Emoji Grid Skeleton */}
      <div className="grid grid-cols-8 gap-2 flex-1 overflow-hidden">
        {[...Array(32)].map((_, i) => (
          <SkeletonBox key={i} className="w-7 h-7" rounded="rounded-md" />
        ))}
      </div>
    </div>
  );
};

export function LazyEmojiPicker(props) {
  return <Picker data={data} {...props} />;
}
